import { render, staticRenderFns } from "./domains_live.vue?vue&type=template&id=0ed4ad2b&"
import script from "./domains_live.vue?vue&type=script&lang=js&"
export * from "./domains_live.vue?vue&type=script&lang=js&"
import style0 from "./domains_live.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports